import { SFCC_INTEGRATION_CLASS } from '@entities/platform-entities/integration/sfcc-integration-class.const';

export function isEnteringSfccIntegration(
  previousIntegrationClass: string,
  nextIntegrationClass: string
): boolean {
  return (
    previousIntegrationClass !== SFCC_INTEGRATION_CLASS &&
    nextIntegrationClass === SFCC_INTEGRATION_CLASS
  );
}
